import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

interface CustomButtonProps {
  type: "button" | "submit";
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
}

const GvSecondaryButton: React.FC<CustomButtonProps> = ({
  type,
  children,
  onClick,
  className,
}) => {
  return (
    <Box>

      <Button
        fullWidth
        type={type}
        sx={{ textTransform: "none" }}
        className={`!bg-transparent hover:!text-black !my-2 ${className}`}
        onClick={onClick}
      >
        {children}
      </Button>
    </Box>
  );
};

export default GvSecondaryButton;
